import { createActionCreator } from "common/ReduxUtils";
import { CreateShipmentFormState } from "../CreateShipmentState";
import { CreateShipmentFormActionTypes } from "../CreateShipmentActionTypes";

export const setSingleSkuPackages = createActionCreator<CreateShipmentFormState["singleSkuPackages"]>(
  CreateShipmentFormActionTypes.SET_SINGLE_SKU_PACKAGES,
  "singleSkuPackages"
);
